import BaseService from '@/features/BaseService';

export default class ZohoReportCredentialService extends BaseService {

  constructor() {
    super('zoho-reports-credential');
  }

}



// WEBPACK FOOTER //
// ./src/features/zoho-report-credential/ZohoCredentialService.js